import { useMutation, useQuery, useQueryClient, UseQueryResult } from "@tanstack/react-query";
import { staffApi } from "./staffApi";
import { PortalSettingsRow } from "../types/dtos";

export function usePortalToggles(): UseQueryResult<PortalSettingsRow> {
  return useQuery({
    queryKey: ["settings", "portal"],
    queryFn: async () => (await staffApi.get<PortalSettingsRow>("/settings/portal")).data,
  });
}

export type PortalTogglesInput = Partial<{
  showFullHistory5y: boolean;
}>;

export function useUpdatePortalToggles() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: PortalTogglesInput) => staffApi.patch<PortalSettingsRow>("/settings/portal", input),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["settings", "portal"] }),
  });
}
